import { Box, Typography, Button, Stack } from '@mui/material'
import { useAuth0 } from '@auth0/auth0-react'
import { PageHeader } from '~/components/Navigation/PageHeader'
import { AUTH0_DOMAIN } from '~/config/auth'
import { DIALOGS, NAV } from '~/components/Charts/chrome/chartChrome'

export function Password() {
  const { user, logout } = useAuth0()
  return (
    <Box sx={{ p: 4 }}>
      <PageHeader title={NAV.password} />
      <Stack spacing={2} maxWidth={480}>
        <Typography>{DIALOGS.resetPasswordHint}</Typography>
        <Button
          variant="outlined"
          onClick={() => {
            window.open(`https://${AUTH0_DOMAIN}/dbconnections/change_password`, '_blank')
          }}
        >
          {DIALOGS.resetPassword}
        </Button>
        <Typography variant="caption" color="text.secondary">
          {DIALOGS.loggedInAs(user?.email ?? '')}
        </Typography>
        <Button
          size="small"
          onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
        >
          {DIALOGS.signOut}
        </Button>
      </Stack>
    </Box>
  )
}
